<template>
    <div class="wrapper col">
        <h2>Expo Name</h2>
        <div class="section">
            <input
                class="text-input"
                v-model="expoName"
                @input="replaceExpoId"
                maxlength="40"
                placeholder="What is the name of your event?"
                v-on:keyup.enter="submit"
            >
            <h2>Expo ID</h2>
            <div>
                <input
                    class="text-input"
                    v-model="expoId"
                    @input="changeExpoId"
                    maxlength="40"
                    placeholder="This is a unique identifier for your expo"
                    spellcheck="false"
                >
            </div>
            <SubmitButton
                @click="submit"
                :isLoading="loading"
                text="Create"
            />
        </div>
        <!--<h1 class="showHide" @click="showHide"><span v-if="!showOptional">Show </span>Optional Settings</h1>
        <transition name="fade">
            <div v-if="showOptional" class="section">
                <span>Start Date</span>
                <div>
                    <input v-model="expoId" maxlength="40" placeholder="This is a unique identifier for your expo">
                </div>
                Maybe just handle this with user invites? like google docs <span>Password</span>
                <div>
                    <input v-model="password" maxlength="40" placeholder="An optional password limiting access to this event">
                </div>
            </div>
        </transition>-->
    </div>
</template>

<script>
import { firestore } from '../../db'

const expos = firestore.collection('expos')

export default {
    name: "NewExpo",
    data() {
        return {
            expoName: '',
            expoId: '',
            startDate: '',
            password: '',
            showOptional: false,
            alteredExpoId: false,
            loading: false,
        }
    },
    methods: {
        submit() {
            if (!this.expoName || !this.expoId) {
                this.error('Don\'t forget to fill in all the fields!')
                return
            }
            this.loading = true
            var expoDoc = expos.doc(this.expoId)
            expoDoc.get().then((snapshot) => {
                if (snapshot.exists) {
                    this.error('There\'s already an expo with that ID!')
                } else {
                    expos.doc(this.expoId).set({
                        name: this.expoName,
                        rooms: {}
                    }).then(() => {
                        this.$router.push('/editexpo/' + this.expoId)
                    })
                }
            }).catch((e) => console.log(e)).finally(() => this.loading = false)
        },
        replaceExpoId() {
            if (!this.alteredExpoId) {
                this.expoId = this.expoName
                this.updateExpoId()
            }
        },
        changeExpoId() {
            this.alteredExpoId = true
            this.updateExpoId()
        },
        updateExpoId() {
            this.expoId = this.expoId.toLowerCase().replaceAll(/\s/gi, '-').replaceAll(/[^0-9a-z-]/gi, '')
        },
        showHide() {
            this.showOptional = !this.showOptional
            this.alteredExpoId = false
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../../interface.scss';
</style>